import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-repeat-formly',
    template: `
  @for (field of field.fieldGroup; track field; let i = $index) {
    <div>
      <formly-group
        [model]="model[i]"
        [field]="field"
        [options]="options"
        [form]="formControl">
      </formly-group>
    </div>
  }
  `,
    imports: [FormlyModule]
})
export class RepeatFormlyComponent extends FieldArrayType {

  constructor() {
    super();
  }
}
